<div class="_bg-grayscale-white">
    <app-nav class="_sticky _top-0 _z-50 _block _border-b _shadow-bottom">
        <div slot="consumer-search" *ngIf="isWhiteLabel" class="search-row sm-max:_hidden">
            <app-search-criteria
                    *ngIf="listing"
                    [aiSearchEnabled]="true"
                    [minimumConsecutiveNights]="minNightsStay"
                    [showModalFilters]="false">
            </app-search-criteria>
        </div>
        <div slot="ta-search" *ngIf="!isWhiteLabel" class="search-row sm-max:_hidden">
            <app-search-criteria
                    *ngIf="listing"
                    [aiSearchEnabled]="true"
                    [minimumConsecutiveNights]="minNightsStay"
                    [showModalFilters]="false">
            </app-search-criteria>
        </div>
    </app-nav>
    <div class="listing-container _flex _flex-col _items-center" *ngIf="listing">
        <div class="md:_container _mx-auto _grid md:_gap-4 _grid-cols-12">
            <div class="_col-span-12 sm:_col-span-8 _px-2 md:_px-0">
                <app-listing-hotel 
                    #listingHotelComponent
                    *ngIf="listing.asset.assetType === AssetType.Hotel"
                    [listing]="listing"
                    [travelDates]="travelDates"
                    (onReserveRoom)="startBookingFlow($event)"
                    (onSuiteSelect)="updateSelectedSuite($event)"
                    (onSuiteThumbnailData)="updateHotelSuitesThumbnails($event)">

                    <!-- TODO: Inserting this here as ng-content after moving the feature image into the property/hotel listing component.
                        Wishlist module needs to be moved to a shareable location outsde of the route directory. -->
                    <ng-container slot="add-to-wishlist-favorites">
                        <div class="_absolute _top-5 _right-5 _hidden xs:_flex" *ngIf="selectedSuite?.hotelSuiteId">
                            <app-add-to-wishlist   
                                [listingId]="selectedSuite.hotelSuiteId"
                                [travelDates]="travelDates">
                            </app-add-to-wishlist>
                        </div>
                    </ng-container>
                </app-listing-hotel>

                <app-listing-property 
                    *ngIf="listing.asset.assetType === AssetType.Property" 
                    [listing]="listing"
                    (onPropertyLoad)="propertyLoaded($event)">
                    <!-- TODO: Inserting this here as ng-content after moving the feature image into the property/hotel listing component.
                        Wishlist module needs to be moved to a shareable location outsde of the route directory. -->
                    <ng-container slot="add-to-wishlist-favorites">
                        <div class="_absolute _top-5 _right-5 _hidden xs:_flex">
                            <app-add-to-wishlist  
                                [listingId]="listing.listingId"
                                [travelDates]="travelDates">
                            </app-add-to-wishlist>
                        </div>
                    </ng-container>
                </app-listing-property>
            </div>
            <div class="_w-auto sm:_col-span-4 _pr-2 md:_pr-0">
                <div class="_drawer _drawer-no-toggle-btn  sm:_sticky sm:_top-listing-nav-offset _overflow-scroll _no-scrollbar"
                    [ngClass]="{ '_drawer-open': openBookingPanel }">
                    <div class="_relative _h-screen _overflow-y-scroll _no-scrollbar _pb-30">

                        <div class="_flex _justify-end _w-full sm:_hidden _px-4 _pt-4">
                            <button class="_button-reset _pr-0"
                            (click)="openMobileBookingPanel(false, $event)">
                                <i class="fa-sharp fa-light fa-chevrons-right"></i>
                            </button>
                        </div>

                        <div class="_max-w-600px _mx-auto">
                            <div class="_panel _bg-grayscale-white _gap-4 sm-max:_border-0 sm-max:_shadow-none">
                                <div *ngIf="listing.asset.assetType === AssetType.Hotel"
                                    class="_w-full" 
                                    [ngClass]="{_hidden: selectedSuite?.hotelSuiteId}">
                                    <div class="_mb-6 _w-full _text-center">
                                        <div class="_h3 _mb-2">Hotel Suites</div>
                                        <div class="_text-md">To see availability and rates please select a suite.</div>    
                                    </div>
                                    <div class="_flex _flex-col _gap-4">
                                        <div *ngFor="let suite of hotelSuitesThumbnailData; let index = index" 
                                            class="_flex _flex-row _gap-4 _items-center _w-full _border _shadow-sm _min-h-16 _cursor-pointer hover:_bg-primary-1-tint-4"
                                            (click)="suiteThumbnailSelect(index)">
                                            <div class="_placeholder-3-2 _rounded-none _min-w-24">
                                                <img *ngIf="suite.image" [source]="suite.image" app-imagekit transform="tr:w-120,h-80,fo-auto" alt="Hotel suite">
                                            </div>
                                            <div class="_flex _flex-col _gap-1">
                                                <div class="_text-md _font-bold">{{suite.name}}</div>
                                                <div *ngIf="suite.maximumOccupancy" class="_text-sm _text-primary-1-tint-50">{{suite.maximumOccupancy}} Guests</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="_w-full" [ngClass]="{_hidden: !selectedSuite?.hotelSuiteId && listing.asset.assetType !== AssetType.Property}">
                                    <div *ngIf="listing && travelDates && listing.asset.assetType === AssetType.Property"
                                        class="_w-full">
                                        <app-listing-travel-dates
                                            #travelDatesComponent
                                            [listingId]="listing.listingId"
                                            [travelDates]="travelDates"
                                            [minimumNights]="listing?.stayDurationConditions?.minimum"
                                            [guestCriteria$]="guestsChanged$"
                                            [businessCustomerReference]="businessCustomerReference"
                                            [maxGuestsExceeded]="maxGuestsExceeded"
                                            (update)="emit($event)"
                                            (reserve)="openBookingConfirmation($event)"
                                            (availableFrom)="setAvailableFromDate($event)"
                                            (rate)="updateBestRate($event)"
                                            (updateFees)="setBestRate($event)"
                                            (commissionIsSet)="updateListingHasCommission($event)"
                                            [consumerView]="consumerView">

                                            <ng-container slot="guests-and-fees">
                                                <form [formGroup]="formGroup">
                                                    <fieldset class="_mt-4">
                                                        <app-search-criteria-guests 
                                                            [inline]="true"
                                                            [showTotalGuests]="false"
                                                            [maxGuests]="maxGuests"
                                                            [guestsRestrictions$]="guestRestrictionsChanged$"
                                                            formControlName="guests"
                                                            (totalGuestsChanged)="updateTotalGuests($event)"
                                                            (guestChanged)="handleGuestChanged($event)"
                                                            (maxGuestsExceeded)="handleMaxGuestsExceeded($event)"
                                                            class="_pb-2">
                                                        </app-search-criteria-guests>
                                                    </fieldset>
                                                </form>
                                                <div class="_flex _items-center _justify-center _mt-3 _gap-2">
                                                    <div class="_pill">
                                                        {{ totalGuests }} {totalGuests, plural, =1 {guest} other {guests}}
                                                    </div>
                                                    <div *ngIf="totalNights" class="_pill">
                                                        {{ totalNights }} {totalNights, plural, =1 {night} other {nights}}
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-container slot="client-reference">
                                                <form [formGroup]="formGroup" class="_mb-8">
                                                    <label for="client-reference" class="_text-md _relative _required-field">Booking name</label>
                                                    <fieldset class="_input-squared _mt-1 _px-4">
                                                        <input
                                                            id="client-reference"
                                                            class="_w-full"
                                                            type="text"
                                                            placeholder="Tip: The name of the lead traveller, group or family."
                                                            formControlName="businessCustomerReference"/>
                                                    </fieldset>
                                                </form>
                                            </ng-container>

                                            <ng-container *ngIf="isTravelAgent" slot="add-to-proposal">
                                                <div class="_mb-4"></div>
                                                <div class="_flex _bg-grayscale-white _gap-4" *feature="'res-141-flok-member-show-shortlist'">
                                                    <div class="_w-full">
                                                        <app-add-to-wishlist 
                                                            [listingId]="listing.listingId"
                                                            [travelDates]="travelDates"
                                                            useTextButton="true">
                                                        </app-add-to-wishlist>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </app-listing-travel-dates>
                                    </div>

                                    <div *ngIf="listing && listing.asset.assetType === AssetType.Hotel" class="_w-full" >

                                        <app-listing-travel-dates
                                            *ngIf="selectedSuite?.hotelSuiteId"
                                            [listingId]="selectedSuite.hotelSuiteId"
                                            [travelDates]="travelDates"
                                            [minimumNights]="1"
                                            [showAvailableInventory]="true"
                                            [businessCustomerReference]="businessCustomerReference"
                                            [maxGuestsExceeded]="maxGuestsExceeded"
                                            (update)="emit($event)"
                                            (reserve)="openBookingConfirmation($event)"
                                            (availableFrom)="setAvailableFromDate($event)"
                                            [guestCriteria$]="guestsChanged$"
                                            (rate)="updateBestRate($event)"
                                            (updateFees)="setBestRate($event)"
                                            (commissionIsSet)="updateListingHasCommission($event)"
                                            [consumerView]="consumerView">

                                            <ng-container slot="guests-and-fees">
                                                <form *ngIf="travelDates && selectedSuite?.hotelSuiteId" 
                                                    [formGroup]="formGroup">
                                                    <fieldset class="_mt-4">
                                                        <app-search-criteria-guests 
                                                            [inline]="true"
                                                            [showTotalGuests]="false"
                                                            [maxGuests]="maxGuests"
                                                            [guestsRestrictions$]="guestRestrictionsChanged$"
                                                            formControlName="guests"   
                                                            (totalGuestsChanged)="updateTotalGuests($event)"
                                                            (guestChanged)="handleGuestChanged($event)"
                                                            (maxGuestsExceeded)="handleMaxGuestsExceeded($event)"
                                                            class="_pb-2">
                                                        </app-search-criteria-guests>
                                                    </fieldset>
                                                </form>
                                                <div class="_flex _items-center _justify-center _mt-3 _gap-2">
                                                    <div class="_pill">
                                                        {{ totalGuests }} {totalGuests, plural, =1 {guest} other {guests}}
                                                    </div>
                                                    <div *ngIf="totalNights" class="_pill">
                                                        {{ totalNights }} {totalNights, plural, =1 {night} other {nights}}
                                                    </div>
                                                </div>                                                    
                                            </ng-container>

                                            <ng-container slot="client-reference">
                                                <form [formGroup]="formGroup" class="_mb-8">
                                                    <label for="client-reference" class="_text-md _relative _required-field">Booking name</label>
                                                    <fieldset class="_input-squared _mt-1 _px-4">
                                                        <input
                                                            id="client-reference"
                                                            class="_w-full"
                                                            type="text"
                                                            placeholder="Tip: The name of the lead traveller, group or family."
                                                            formControlName="businessCustomerReference"/>
                                                    </fieldset>
                                                </form>
                                            </ng-container>

                                            <ng-container *ngIf="isTravelAgent && selectedSuite?.hotelSuiteId" slot="add-to-proposal">
                                                <div class="_mb-4"></div>
                                                <div class="_flex _bg-grayscale-white _gap-4" *feature="'res-141-flok-member-show-shortlist'">
                                                    <div class="_w-full">
                                                        <app-add-to-wishlist 
                                                            [listingId]="selectedSuite.hotelSuiteId"
                                                            [travelDates]="travelDates"
                                                            useTextButton="true">
                                                        </app-add-to-wishlist>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </app-listing-travel-dates>

                                        <!-- TODO: Set minimum booking rate for hotel (not suite)-->
                                        <ng-container *ngIf="!selectedSuite?.hotelSuiteId">
                                            <div class="_flex _flex-col _gap-8 _px-4 _py-8">
                                                <div class="_text-sm _text-center">View each suite for rates and instant bookings
                                                </div>

                                                <span class="_text-lg _text-center">
                                                    Best available rate
                                                    <span class="_font-bold">
                                                        <app-booking-price [fees]="fees"></app-booking-price>
                                                    </span>
                                                    <ng-container *ngIf="!travelDates.checkin && !travelDates.checkout">
                                                        per night
                                                    </ng-container>
                                                    <div class="_text-sm _text-primary-1-tint-50 _mt-2">(low season, minimum guests)</div>
                                                </span>

                                                <ng-container *ngIf="commission && !consumerView">
                                                    <app-reseller-commission-calculation
                                                        [caption]="'Your commission'"
                                                        [showAmount]="true"
                                                        [showPercentage]="true"
                                                        [exactFee]="fees"
                                                        [commission]="commission">
                                                    </app-reseller-commission-calculation>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="(listing.asset.assetType === AssetType.Hotel && selectedSuite?.hotelSuiteId) || listing.asset.assetType === AssetType.Property"
                                class="_flex _flex-col _text-md _p-4 _gap-2 sm-max:_hidden">
                                <div *ngIf="availableFromDate" class="_flex _justify-between _flex-col md:_flex-row _gap-2">
                                    <div class="_flex _justify-start _gap-3">
                                        <span>Available from</span><span class="_font-bold">{{ availableFromDate }}</span>
                                    </div>
                                    <span class="_link _underline" (click)="openCalendar()">Show availability</span>
                                </div>
                                <div *ngIf="minNightsStay" class="_flex _justify-between _flex-col md:_flex-row _gap-2">
                                    <div *ngIf="minNightsStay" class="_flex _gap-3">
                                        <span>Minimum stay</span><span class="_font-bold">{{ minNightsStay }} nights</span>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="listing && (listing.asset.assetType === AssetType.Hotel && selectedSuite?.hotelSuiteId) || listing.asset.assetType === AssetType.Property">
            <div class="_fixed _bottom-0 _left-0 _w-full _p-3 _bg-primary-1 _z-10 _border-t _border-transparency-black-25 _shadow-top _text-white sm:_hidden">
                <div class="_relative _w-full _h-full _text-center _flex _flex-col _gap-2">
                    <div class="_bg-primary-1 _shadow-top _absolute _-top-8 _-left-3 _h-11 _w-11 _pt-2 _rounded-full _flex _items-start _justify-center _cursor-pointer _z-below"
                        (click)="expandMobileFooter = !expandMobileFooter">
                        <i class="fa-light" [ngClass]="expandMobileFooter ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </div>
                    <div *ngIf="expandMobileFooter">
                        <div class="_text-sm"><span class="_underline">Add guests and dates</span> to view booking rates.</div>
                        <div class="_text-sm" *ngIf="listingHasCommission && !consumerView">Then adjust your commission.</div>
                    </div>
                    <app-button (click)="openBookingPanel = true" type="primary-dark" modifierClassNames="_w-full _max-w-600px _mx-auto">
                        Best available rate 
                        <span *ngIf="listingHasCommission" class="_pl-1">
                            {{ bestRate }}
                        </span>
                        <span *ngIf="!listingHasCommission" class="_pl-1"> 
                            <app-booking-price [fees]="fees"></app-booking-price>
                        </span>
                    </app-button>
                    <div *ngIf="expandMobileFooter && listingHasCommission && !consumerView" class="_text-sm">Earn up to <span class="_font-bold">25%</span> commission.</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
